/* @ngInject */
const myWagonDisplay = () => {
  return {
    restrict: 'E',
    scope: {
      myWagon: '=',
      enableButtons: '=?',
      enableBack: '=?',
    },
    template: require('./myWagonDisplay.html'),

    /* @ngInject */
    controller: ($scope) => {

    },
    link: {
      pre: (scope, element, attrs) => { },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}

export default myWagonDisplay



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/display/myWagonDisplay.js